import { DocumentEditSessionLimit } from './document-edit-session-limit';

DocumentEditSessionLimit.initialize();

export {
	DocumentEditSessionLimit,
};
